import EzController from 'controllers/ez-base-controller';
import {
  sendTrackingEvent,
  pushDataLayerProperties,
} from 'components/analytics/conversions/tracking';
import {
  CONTENT_SELECTION_CLICK,
  SHOW_PAGE_MODAL_CLICK,
} from 'components/analytics/conversions/constants/actions';
import {
  triggerCustomEvent,
  featureEnabled,
  getPercentage,
  getWindowWidth,
} from 'lib/helpers'; // split-test: iscroll_modal
import { getAjaxModal, ajaxPost } from 'lib/ajax-helpers'; // split-test: iscroll_modal
import { displayShowPopup } from 'lib/partner-popup-helpers';
import events from 'lib/events'; // split-test: iscroll_modal
import Cookies from 'js-cookie';

require('intersection-observer');

export default class ResourcesGridController extends EzController {
  static values = {
    trackTruncation: Boolean,
  };

  static targets = ['gridItem'];

  gridObserver = null;

  get shouldTrackTruncation() {
    return this.hasTrackTruncationValue && this.trackTruncationValue;
  }

  connect() {
    this.initGrid();

    window.addEventListener('InitAllGrids', this.initGrid);

    if (this.element.parentNode.classList.contains('ez-search-results')) {
      this.insertSearchDeboostingButtons();
    }

    if (this.shouldTrackTruncation) {
      this.trackResourceTruncation();
    }

    this.element.addEventListener('contextmenu', this.trackResourceRightClick);
  }

  trackResourceTruncation() {
    if (!this.hasGridItemTarget) return;

    const totalItemCount = this.gridItemTargets.length;
    const totalItemsHidden = this.gridItemTargets.filter((item) => item.style.display === 'none').length;
    const percentHidden = getPercentage(totalItemsHidden, totalItemCount);

    pushDataLayerProperties({ search_results_percent_hidden: percentHidden });
  }

  disconnect() {
    window.removeEventListener('InitAllGrids', this.initGrid);
    this.element.removeEventListener('contextmenu', this.trackResourceRightClick);

    if (this.gridObserver) this.gridObserver.disconnect();
  }

  remove = () => {
    this.element.remove();
  }

  initGrid = (event = false) => {
    if (this.element.classList.contains('ez-resource-grid--partner')) return;

    // if an event is present, its not the first load and we should trigger even instant grids
    if (!this.element.dataset.instantGrid || (this.element.dataset.instantGrid && event)) {
      window.ezResourceGrid({
        gridSelector: this.element,
        options: {
          rowHeight: parseInt(this.element.getAttribute('data-row-height'), 10),
          maxRows: parseInt(this.element.getAttribute('data-max-rows'), 10),
          truncate: !!this.element.getAttribute('data-truncate-results'),
        },
      });
    }

    const gridItems = this.element.querySelectorAll('.ez-resource-grid__item');
    gridItems.forEach((item, index) => {
      item.setAttribute('data-position', index + 1);
    });
  }

  trackResourceClick = (event) => {
    const gridListItem = event.currentTarget.closest('.ez-resource-thumb');
    const licenseType = gridListItem.dataset.pro === 'true' ? 'Pro' : 'Free';

    sendTrackingEvent({
      element: event.currentTarget,
      data: {
        action: CONTENT_SELECTION_CLICK,
        label: licenseType,
        content_type: `Content-${event.currentTarget.dataset.contentType}`,
      },
    });

    if (licenseType === 'Free') {
      displayShowPopup({ searchTerm: this.searchTerm || Cookies.get('most_recent_search') });
    }
  }

  trackResourceRightClick = (event) => {
    const gridListItem = event.target.closest('.ez-resource-thumb');
    if (!gridListItem) return;

    const licenseType = gridListItem.dataset.pro === 'true' ? 'Pro' : 'Free';
    if (licenseType === 'Free') {
      displayShowPopup({ display: false });
    }
  }

  loadModalShow = (event) => {
    // start split-test: iscroll_modal
    if (getWindowWidth() > 1000) {
      event.preventDefault();

      const resourceShowUrl = event.currentTarget.getAttribute('href');

      getAjaxModal(resourceShowUrl);

      this.sendShowPageModalClick(event);

      triggerCustomEvent(events.show_page.modal.build_resource_navigation_context, {
        targetResourcePath: resourceShowUrl,
        targetResourceGroup: event.currentTarget.closest('[data-controller*="resources-grid"]'),
      });
    }
    // end split-test: iscroll_modal
  }

  sendShowPageModalClick(event) {
    const licenseType = event.currentTarget.closest('.ez-resource-thumb').dataset.pro === 'true' ? 'Pro' : 'Free';

    sendTrackingEvent({
      element: event.currentTarget,
      data: {
        action: SHOW_PAGE_MODAL_CLICK,
        label: licenseType,
        content_type: `Content-${event.currentTarget.dataset.contentType}`,
      },
    });
  }

  // quick and dirty for Shawn, refactor me
  insertSearchDeboostingButtons() {
    if (this.showDeboost) {
      const allResultsGridItems = document.querySelectorAll('.ez-search-results .ez-resource-thumb__link');
      allResultsGridItems.forEach((item) => {
        const nopeButton = document.createElement('DIV');

        nopeButton.classList.add('ez-resource-thumb__link__admin');
        nopeButton.classList.add('ez-resource-thumb__link__admin--nope');
        nopeButton.dataset.action = 'click->resources-grid#nopeResource';

        item.appendChild(nopeButton);
      });

      const grid = document.querySelectorAll('.ez-resource-grid')[0];
      const termButton = document.createElement('a');
      const termLink = document.createTextNode('exclude term');
      termButton.appendChild(termLink);
      termButton.dataset.action = 'click->resources-grid#excludeTerm';
      termButton.href = '#';
      grid.appendChild(termButton);
    }
  }

  get showDeboost() {
    return document.body.classList.contains('is-admin')
    && document.body.classList.contains('searches-show')
    && featureEnabled('search-deboost')
    && this.contentType !== 'vector';
  }

  nopeResource = (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();

    const ajaxUrl = '/admin/search/search_term_options/exclude';

    ajaxPost(
      ajaxUrl,
      this.afterSearchTweak,
      () => { /* do nothing */ },
      this.stoParams(this.parseResourceId(event)),
    );
  }

  excludeTerm = (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();

    // eslint-disable-next-line no-alert
    const excluded = prompt('enter term to exclude');

    const params = {
      term: this.searchTerm,
      locale: this.locale,
      content_type: this.contentType,
      excluded_term: excluded,
    };

    const ajaxUrl = '/admin/search/search_term_options/exclude_term';

    ajaxPost(
      ajaxUrl,
      this.afterSearchTweak,
      () => { /* do nothing */ },
      params,
    );
  }

  stoParams = (resourceId) => ({
    term: this.searchTerm,
    locale: this.locale,
    content_type: this.contentType,
    resource_id: resourceId,
  })

  afterSearchTweak = () => {
    window.EezyScrollPositionHelper.preservePositionOnce();
    Turbolinks.visit(window.location);
  }

  get searchTerm() {
    const searchInfo = document.querySelector('[data-search-term]');
    if (searchInfo) {
      return searchInfo.getAttribute('data-search-term');
    }

    return '';
  }

  get locale() {
    return document.documentElement.getAttribute('lang');
  }

  get contentType() {
    return document.querySelector('#search').getAttribute('data-content-type');
  }

  parseResourceId(event) {
    const resourceId = event.target.parentNode.parentNode.dataset.itemId;
    return resourceId;
  }
}
